import {Component, OnInit, OnDestroy} from '@angular/core';
import {SpecializationsService} from '../../services/specializations.service';
import {TreeNode} from 'primeng/primeng';

@Component({
  selector: 'app-specializations-list',
  templateUrl: './specializations-list.component.html',
  styleUrls: ['./specializations-list.component.css']
})
export class SpecializationsListComponent implements OnInit, OnDestroy {
  selection = [];
  data: TreeNode[];
  isLoaded = false;

  selectedItem = undefined;

  constructor(public specializationsServ: SpecializationsService) {
  }

  ngOnInit() {
    this.getListOfSpecs();
    this.specializationsServ.clearNodeSelection();
  }

  public ngOnDestroy() {
    this.specializationsServ.createSpecSuccess = false;
    this.specializationsServ.updateSpecSuccess = false;
    this.specializationsServ.updateSpecGroupSuccess = false;
    this.specializationsServ.fileUploadFailed = false;
  }

  getListOfSpecs() {
    this.specializationsServ.getAllSpecs().subscribe(
      (response: any) => {
        if (response.status === 204) {
          this.specializationsServ.noSpecializations = true;
          this.isLoaded = true;
        }
        if (response.status === 200) {
          this.specializationsServ.setNodes(response.body);
          this.specializationsServ.noSpecializations = false;
          this.specializationsServ.getSpecializationsError = false;
          this.isLoaded = true;
        }
      },
      (error) => {
        if (error.status === 500) {
          this.specializationsServ.getSpecializationsError = true;
          this.isLoaded = true;
        }
        if (error.status === 502) {
          this.specializationsServ.getSpecializationsError = true;
          this.isLoaded = true;
        }
      }
    );
  }

  nodeSelect(event) {
    this.specializationsServ.nodeId = event.node.data.id;
    this.specializationsServ.nodeName = event.node.data.name;
    this.specializationsServ.nodeType = event.node.data.type;
    this.specializationsServ.nodePosition = event.node.data.position;
  }

  nodeUnselect() {
    this.selection = [];
    this.specializationsServ.clearNodeSelection();
  }

  closeAlert() {
    this.specializationsServ.createSpecSuccess = false;
    this.specializationsServ.updateSpecGroupSuccess = false;
  }

  onNodeDblClick(event) {
    if (event.node.data.type === 'Group') {
      event.node.expanded = !event.node.expanded;
    }
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/specializations/components/specializations-list/specializations-list.component.ts